import React, { useEffect, useState } from "react";
import { Box, FormControl, Grid, Link, FormLabel, Modal, Typography, Button } from "@mui/material";
import PageTitle from "../../common/PageTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { Controller, useForm } from "react-hook-form";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import { getAPI, postAPI, patchAPI, deleteAPI } from "../../network";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import BasicSelector from "../../common/Selector";

import { checkAuthority, formatDate, validation, tableHeader, tableData, tablebtn } from "../../utils";
import Loader from "../../common/Loader";
import EmptyTable from "../../common/EmptyTable";
import { Security } from "@mui/material";

export default function Company() {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState('');
  const [code, setCode] = useState('')
  const [typeError, setTypeError] = useState(false);
  const [editId, setEditId] = useState('');
  const [action, setAction] = useState('');
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [countries, setCountries] = useState([])
  const [cities, setCities] = useState([])
  const [companies, setCompanies] = useState([]);
  const [licenseType, setLicenseType] = useState();
  const [countryF, setCountryF] = useState();
  const [stateF, setStateF] = useState();
  const [person, setPerson] = useState({
    name: '',
    country: '',
    state: '',
    type: '',
    nameError: false,
    countryError: false,
    stateError: false
  })

  const [page, setPage] = useState(0)
  const [perPages, setPerPages] = useState([5, 10, 25, 50]);
  const [perPage, setPerPage] = useState(10)

  useEffect(() => {
    getCompanies();
    getCountries();
    // getStates();
  }, []);

  const getCompanies = async (type, country, state) => {
    setLoader(true);
  
    const params = {};
    if (type) params.type = type;
    if (country) params.country = country;
    if (state) params.state = state;
  
    const searchParams = new URLSearchParams(params).toString();
    const url = `/getlicense${searchParams ? `?${searchParams}` : ''}`;
  
    try {
      const data = await getAPI(url);
      if (data) setCompanies(data);
    } finally {
      setLoader(false);
    }
  };
  

  const getStates = async (countryId) => {
    let code = countries.filter((item) => item._id === countryId)[0]
    setCode(code?._id)
    setLoader(true)
    const data = await getAPI(`/states?countryId=${code?._id}`);
    if (data) {
      setCities(data)
    }
    setLoader(false)
  }

  const alltypes = [
    { type: "Security" },
    { type: "Other" },

  ]
  const getCountries = async () => {
    setLoader(true)
    const data = await getAPI('/countries');
    if (data) {
      setCountries(data)
    }
    setLoader(false)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const handleChangeRowsPerPage = (event) => {
    console.log(event.target.value)
    setPerPage(event.target.value)
    setPage(0);
  };


  const addLicense = (e) => {
    e.preventDefault();
    setAction('add');
    clearAll();
    setOpen(true)
  }

  const editlicense = (e, id) => {
    e.preventDefault();
    setEditId(id)
    clearAll();
    let data = companies.filter(item => item._id === id)[0];
    setPerson(prevState => ({
      ...prevState,
      name: data?.name,
      country: data?.country?._id,
      state: data?.state?._id,
      type: data?.type,
      nameError: false,
      countryError: false,
      stateError: false
    }))
    getStates(data?.country._id)

    setAction('edit');
    setOpen(true)

  }

  const deleteCompany = (id) => {

    setEditId(id);
    clearAll();
    setShow(true);
  }

  const clearAll = () => {
    setPerson({
      name: '',
      country: '',
      state: '',
      type: '',
      nameError: false,
      countryError: false,
      stateError: false
    })
  }

  const handleClose = () => {
    setOpen(false)
  }
  const handleShowClose = () => {
    setShow(false);
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    setPerson(prevState => ({
      ...prevState,
      nameError: false,
      countryError: false,
      stateError: false,
      typeError: false,
    }))

    if (validation(null, 'Name', person.name)) {
      setPerson(prevState => ({
        nameError: true,
      }))
      return;
    }
    else if (validation('empty', 'Country', person.country)) {
      setPerson(prevState => ({
        ...prevState,
        countryError: true,
      }))
      return;
    }
    else if (validation('empty', 'City', person.state)) {
      setPerson(prevState => ({
        ...prevState,
        stateError: true,
      }))
      return;
    }
    else if (validation('empty', 'Type', person.type)) {
      setPerson(prevState => ({
        ...prevState,
        typeError: true,
      }))
      return;
    }



    let payload = {
      name: person.name,
      country: person.country,
      state: person.state,
      type: person.type,
    }


    if (action === 'add') {
      setLoader(true)
      let data = await postAPI('/getlicense', payload)
      //  console.log(data,"data")
      if (data) {
        getCompanies()
        setOpen(false)
      }
      setLoader(false)
    }
    else {
      setLoader(true)
      let data = await patchAPI(`/getlicense/${editId}`, payload)
      if (data) {
        getCompanies()
        setOpen(false)
      }
      setLoader(false)
    }
  }

  const handleDelete = async () => {
    setLoader(true);
    let process = await deleteAPI(`/getlicense/${editId}`);
    setLoader(false);
    if (process) {
      getCompanies();
      setShow(false)
    }
  }
  // Each handler updates its value and triggers filter
  const onChangeLicense = (event) => {
    const value = event.target.value;
    setLicenseType(value);
    getCompanies(value, countryF, stateF);
  };

  const onChangeCountry = (event) => {
    const value = event.target.value;
    setCountryF(value);
    setStateF(""); // clear state if needed
    getCompanies(licenseType, value, ""); // Optionally pass "" for state or the latest state value if you keep it
    getStates(value); // if you want to refresh states for this country
  };

  const onChangeState = (event) => {
    const value = event.target.value;
    setStateF(value);
    getCompanies(licenseType, countryF, value);
  };

  const [permissionList, setPermissionList] = useState([]);

  // Load the permission list from localStorage
  useEffect(() => {
    const permissions = JSON.parse(localStorage.getItem("permisionlist")) || [];
    setPermissionList(permissions);
  }, []);

  const submenuPermissions = permissionList[0]?.submenuPermissions || [];

  // Check if 'Delete' and 'Edit' subActions exist

  const canDelete = submenuPermissions.some(
    (permission) => permission.submenu === "Delete"
  );
  const canEdit = submenuPermissions.some(
    (permission) => permission.submenu === "Edit"
  );
  const canAdd = submenuPermissions.some(
    (permission) => permission.submenu === "Add"
  );

  // If submenuPermissions is empty, show both buttons
  const showBothButtons = submenuPermissions.length === 0;
  return (
    <Box sx={{ height: "inherit" }}>
      <Loader loader={loader} />
      <PageTitle title="License" subTitle="" />
      <Grid item xs={7} py={2}>


        <FormControl sx={{ my: 1, minWidth: "25%", marginLeft: "15px" }}>
          <InputLabel id="shiftType-label">Country</InputLabel>
          <Select
            value={countryF}
            onChange={onChangeCountry}
            displayEmpty
            labelId="shiftType-label"
            id="shiftType"
            label="Country"
            sx={{
              borderRadius: "10px",
              borderColor: "#707070",
              pl: 2,
            }}
          >

            {
              countries.map((item, index) => (
                <MenuItem value={item._id} key={index}>{item.name}</MenuItem>
              ))
            }
          </Select>
        </FormControl>

        <FormControl sx={{ my: 1, minWidth: "25%", marginLeft: "10px" }}>
          <InputLabel id="shiftType-label">State</InputLabel>
          <Select
            value={stateF}
            onChange={onChangeState}
            displayEmpty
            labelId="shiftType-label"
            id="shiftType"
            label="State"
            sx={{
              borderRadius: "10px",
              borderColor: "#707070",
              pl: 2,
            }}
          >
            {
              cities.map((item, index) => (
                <MenuItem value={item._id} key={index}>{item.name}</MenuItem>
              ))
            }
          </Select>
        </FormControl>

        <FormControl sx={{ my: 1, minWidth: "25%", marginLeft: "10px" }}>
          <InputLabel id="shiftType-label">License Type</InputLabel>
          <Select
            value={licenseType}
            onChange={onChangeLicense}
            displayEmpty
            labelId="shiftType-label"
            id="shiftType"
            label="License Type"
            sx={{
              borderRadius: "10px",
              borderColor: "#707070",
              pl: 2,
            }}
          >

            <MenuItem value="Security">Security</MenuItem>
            <MenuItem value="Others">Others</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {
        checkAuthority('ADD_COMPANY') &&
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="flex-end"
          sx={{ mx: 2 }}
        >
          {(showBothButtons || canAdd) && (
            <Button variant="contained" style={{ backgroundColor: "#75859D" }} sx={{ height: 50 }} onClick={addLicense}>
              <AddCircleIcon /> &nbsp; &nbsp;
              Add License
            </Button>
          )}
        </Box>
      }
      {
        checkAuthority('VIEW_COMPANIES') &&
        <Box display="flex" sx={{ my: "2rem" }}>
          <TableContainer component={Paper} sx={{ mx: "1rem" }}>
            <Table
              sx={{ minWidth: "auto" }}
              aria-label="custom pagination table"
              className="responsive-table"
            >
              <TableHead>
                <TableRow className="table-header" align="center">
                  <TableCell align="left" component="th" sx={tableHeader}>
                    License Name
                  </TableCell>
                  <TableCell align="center" component="th" sx={tableHeader}>
                    Country
                  </TableCell>
                  <TableCell align="center" component="th" sx={tableHeader}>
                    State
                  </TableCell>
                  <TableCell align="center" component="th" sx={tableHeader}>
                    Type
                  </TableCell>

                  <TableCell align="center" component="th" sx={tableHeader} >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {companies.slice(page * perPage, page * perPage + perPage).map((item, index) => (
                  <TableRow key={index}>
                    <TableCell align="left" sx={tableData}>
                      <Link to="#" underline="none" className="link-hover">
                        {item.name}
                      </Link>
                    </TableCell>
                    <TableCell align="center" sx={tableData}>
                      {item.country?.name}
                    </TableCell>
                    <TableCell align="center" sx={tableData}>
                      {item.state?.name}
                    </TableCell>
                    <TableCell align="center" sx={tableData}>
                      {item.type}
                    </TableCell>

                    <TableCell align="center" sx={tablebtn}>
                      {
                        (showBothButtons || canEdit) && checkAuthority('EDIT_LICENSE') &&
                        <Button variant="outlined" className="btn-div" color="info" sx={{ mx: 1 }} onClick={(e) => editlicense(e, item?._id)}>
                          <EditIcon className="" />
                        </Button>
                      }
                      {
                        (showBothButtons || canDelete) && checkAuthority('DELETE_LICENSE') &&
                        <Button variant="outlined" className="btn-div" color="error" onClick={() => deleteCompany(item?._id)}>
                          <DeleteIcon className="" />
                        </Button>
                      }
                    </TableCell>

                  </TableRow>
                ))}
                {
                  companies.length === 0 &&
                  <EmptyTable colSpan={7} />
                }


              </TableBody>
              <TableFooter>
                <TableRow>

                  <TablePagination
                    align="right"
                    rowsPerPageOptions={perPages}
                    colSpan={9}
                    count={companies.length}
                    rowsPerPage={perPage}
                    page={page}
                    SelectProps={{
                      inputProps: {
                        'aria-label': 'rows per page',
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  // ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Box>
      }
      <Dialog open={open} onClose={handleClose} fullWidth={true}>
        <DialogTitle sx={{ mb: 4, textAlign: "center" }}>{action === 'add' ? 'Add' : 'Edit'} License</DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { my: 2, width: '100%' },
            }}
            noValidate
            autoComplete="off"
          >


            <FormControl sx={{ minWidth: '100%', mx: 0, px: 0 }}>
              <TextField
                id="name"
                label="License Name"
                variant="outlined"
                type="text"
                value={person.name}
                error={person.nameError}
                onChange={(data) => {
                  setPerson(prevState => ({
                    ...prevState,
                    name: data.target.value,
                  }))
                }}
                fullWidth
                sx={{ m: 0 }}
              />
            </FormControl>
            <FormControl sx={{ minWidth: '100%', mt: 1 }}>
              <InputLabel id="country-label">Country</InputLabel>
              <Select
                labelId="country-label"
                id="country"
                value={person.country}
                label="Country"
                error={person.countryError}
                onChange={(data) => {
                  setPerson(prevState => ({
                    ...prevState,
                    country: data.target.value,
                  }))
                  getStates(data.target.value);
                }}
              >
                {
                  countries.map((item, index) => (
                    <MenuItem value={item._id} key={index}>{item.name}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>


            <FormControl sx={{ minWidth: '100%', mt: 2 }}>
              <InputLabel id="city-label">State</InputLabel>
              <Select
                labelId="city-label"
                id="city"
                value={person.state}
                label="State"
                error={person.stateError}
                onChange={(data) => {
                  setPerson(prevState => ({
                    ...prevState,
                    state: data.target.value,
                  }))
                }}
              >
                {
                  cities.map((item, index) => (
                    <MenuItem value={item._id} key={index}>{item.name}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>


            <FormControl sx={{ minWidth: '100%', mt: 2 }}>
              <InputLabel id="type-label">Type</InputLabel>
              <Select
                labelId="type-label"
                label="Type"
                value={person.type}
                onChange={(data) => {
                  setPerson(prevState => ({
                    ...prevState,
                    type: data.target.value,
                  }))
                }}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                {/* <MenuItem value="">
                Type
              </MenuItem> */}
                {alltypes.map((item, index) => (
                  <MenuItem value={item.type} key={index}>
                    {item.type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>





          </Box>
        </DialogContent>
        <DialogActions sx={{ mb: 2, mx: 4 }}>
          <Button onClick={handleSubmit} variant="contained">{action === 'add' ? 'Submit' : 'Update'}</Button>
          <Button onClick={handleClose} variant="outlined">Cancel</Button>
        </DialogActions>
      </Dialog>


      {/* delete Modal */}
      <Dialog open={show} onClose={handleShowClose} fullWidth={true}>
        <DialogTitle sx={{ mb: 4, textAlign: "center" }}>Delete License</DialogTitle>

        <DialogContent>
          <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { my: 2, width: '100%' },
            }}
            noValidate
            autoComplete="off"
          >

            <h3 style={{ textAlign: 'left', fontWeight: 'bold' }}>Do you want's to delete this license </h3>
          </Box>
        </DialogContent>
        <DialogActions sx={{ mb: 2, mx: 4 }}>
          <Button onClick={handleDelete} variant="contained" color="error">Delete</Button>
          <Button onClick={handleShowClose} variant="outlined">Cancel</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
